import { fg } from '@confluence/feature-gating';
import { query } from '@confluence/query-preloader-tools';

import { useDataRetentionPolicyGetPolicyQuery } from '../hooks/useDataRetentionPolicy';

interface PreloadDataRetentionQueryI {
	cloudId: string;
}

export const preloadDataRetentionPolicy = async ({ cloudId }: PreloadDataRetentionQueryI) => {
	if (!cloudId || !fg('dlp-dlm-data-retention-policy')) {
		return;
	}

	return query({
		query: useDataRetentionPolicyGetPolicyQuery,
		variables: { cloudId },
		errorPolicy: 'all',
	});
};
